import * as React from 'react';

import { TableCell, TableRow } from 'components/table';

import CampaignsTableBrandCell from 'modules/organizations/components/campaigns-table/CampaignsTableBrandCell';
import CcmCampaignsTableCampaignCell from '../cell/campaign/CcmCampaignsTableCampaignCell';
import CcmCampaignsTableOutfitsCell from '../cell/outfits/CcmCampaignsTableOutfitsCell';
import CcmCampaignsTableBudgetCell from '../cell/budget/CcmCampaignsTableBudgetCell';
import CcmCampaignsTableActionsCell from '../cell/actions/CcmCampaignsTableActionsCell';

import './ccm-campaigns-table-row.scss';

import type {
  CampaignWithSubcampaignMeta
} from 'types';

type Props = {
  campaign: CampaignWithSubcampaignMeta
};

const CcmCampaignsTableRow: React.FC<Props> = ({
  campaign
}): JSX.Element => {
  const renderBrandCell = (): React.ReactNode => (
    <TableCell
      width="tiny"
      overflow="hidden"
    >
      <CampaignsTableBrandCell
        brandProfile={campaign.brandProfile}
        brandProfileId={campaign.brandProfileId}
      />
    </TableCell>
  );

  const renderCampaignCell = (): React.ReactNode => (
    <TableCell
      width="fill"
      overflow="hidden"
    >
      <CcmCampaignsTableCampaignCell
        campaign={campaign}
      />
    </TableCell>
  );

  const renderOutfitsCell = (): React.ReactNode => (
    <TableCell
      width="148px"
      className="ccm-campaigns-table-row__cell"
    >
      <CcmCampaignsTableOutfitsCell
        campaign={campaign}
      />
    </TableCell>
  );

  const renderBudgetCell = (): React.ReactNode => (
    <TableCell
      width="214px"
      className="ccm-campaigns-table-row__cell"
    >
      <CcmCampaignsTableBudgetCell
        campaign={campaign}
      />
    </TableCell>
  );

  const renderActionsCell = (): React.ReactNode => (
    <TableCell
      width="270px"
      className="ccm-campaigns-table-row__cell ccm-campaigns-table-row__cell--actions"
    >
      <CcmCampaignsTableActionsCell
        campaign={campaign}
      />
    </TableCell>
  );

  return (
    <TableRow nowrap>
      {renderBrandCell()}
      {renderCampaignCell()}
      {renderOutfitsCell()}
      {renderBudgetCell()}
      {renderActionsCell()}
    </TableRow>
  );
};

export default CcmCampaignsTableRow;
